import React, { memo, useState } from 'react';

// components
import ReviewCard, { REVIEW_DETAILS_SOURCES } from 'shared/components/ReviewCard';
import { Row, MeasureRowHeight } from 'shared/components/Virtualize';

interface IReviewRowProps {
  review: Review.IReviewData;
  index: number;
  productId: string;
  isMobile?: boolean;
}

function ReviewRow({ review, index, productId, isMobile }: IReviewRowProps) {
  const [height, setHeight] = useState(0);

  if (height === 0) {
    return (
      <MeasureRowHeight onMeasured={setHeight}>
        <ReviewCard
          review={review}
          productId={productId}
          source={REVIEW_DETAILS_SOURCES.ALL_REVIEW_PAGE}
          isMobile={isMobile}
        />
      </MeasureRowHeight>
    );
  }

  return (
    <Row height={height} index={index}>
      <ReviewCard
        review={review}
        productId={productId}
        source={REVIEW_DETAILS_SOURCES.ALL_REVIEW_PAGE}
        isMobile={isMobile}
      />
    </Row>
  );
}

export default memo(ReviewRow);
